import React, {createContext, useContext, useState} from 'react';
import PropTypes from 'prop-types';

// Create the context
const LanguageContext = createContext();

// Create the provider component
export const LanguageProvider = ({children}) => {
  const [selectedLanguage, setSelectedLanguage] = useState('en');

  const updateLanguage = language => {
    setSelectedLanguage(language);
  };

  return (
    <LanguageContext.Provider value={{selectedLanguage, updateLanguage}}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook for using the Language Context
export const useLanguage = () => useContext(LanguageContext);

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired
};
